import * as React from "react";
import styled from "styled-components";
import { palette, color, Badge, ArrowPointUp } from "@conserveit/blocks";

interface BadgeTheme {
  [key: number]: {
    background: string;
    foreground: string;
  };
}

export const badgeTheme: BadgeTheme = {
  1: {
    background: palette.red7,
    foreground: color.pureWhite,
  },
  2: {
    background: palette.red5,
    foreground: color.pureWhite,
  },
  3: {
    background: color.pureWhite,
    foreground: palette.neutral7,
  },
  // HACK: This variation isn't visible, see comment below
  0: {
    background: color.pureWhite,
    foreground: palette.neutral7,
  },
};

// HACK: Used to hide the priority when its value is 0
const StyledBadge = styled(Badge)<{ isHidden: boolean }>`
  visibility: ${(props) => (props.isHidden ? "hidden" : "visible")};
`;

type Props = {
  priority: number;
};

export const PriorityBadge: React.FC<Props> = ({ priority }) => {
  return (
    <StyledBadge
      isHidden={priority === 0}
      foregroundColor={badgeTheme[priority].foreground}
      backgroundColor={badgeTheme[priority].background}
    >
      <ArrowPointUp tiny />
      &nbsp;P{priority}
    </StyledBadge>
  );
};
